import React, { createContext } from 'react';
import TokenRefresh from './TokenRefresh';
import { getToken } from '../utils';
import { getAuthUrlParams, useUser } from '../services';
export const AuthContext = createContext({
    user: null,
    token: '',
});
AuthContext.displayName = 'AuthContext';
function AuthProvider({ children }) {
    const { userId, token } = getAuthUrlParams();
    const { user, loading } = useUser(userId, token);
    return loading ? (React.createElement(React.Fragment, null, "Loading user data...")) : (React.createElement(AuthContext.Provider, { value: {
            user,
            get token() {
                return getToken();
            },
        } },
        children,
        React.createElement(TokenRefresh, null)));
}
function useAuth() {
    const context = React.useContext(AuthContext);
    if (context === undefined) {
        throw new Error('useAuth must be used within a AuthProvider');
    }
    return context;
}
export { AuthProvider, useAuth };
//# sourceMappingURL=AuthProvider.js.map